import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";
import { adnPageSize } from "../components/common/GeneralConfigurations";

const memberProfileApiUrl = `${baseApiUrl}/api/MemberProfiles`;

export async function getMemberProfiles(name = "", experience = 0, isHardCheck = false, pageNumber = 1, orderBy = "") {
    return await httpRequest(fetchMemberProfiles.bind(this, name, experience, isHardCheck, pageNumber, adnPageSize, orderBy));
}

async function fetchMemberProfiles(name, experience, isHardCheck, pageNumber, pageSize, orderBy) {
    let config = getHttpHeaders();
    return await axios.get(`${memberProfileApiUrl}?Name=${name}&Experience=${experience}&IsHardCheck=${isHardCheck}&pageNumber=${pageNumber}&pageSize=${pageSize}
  &orderBy=${orderBy}`, config);
}

export async function updateMemberProfile(memberProfile) {
  return await httpRequest(putMemberProfile.bind(this, memberProfile));
}

async function putMemberProfile(memberProfile) {
  let config = getHttpHeaders();
  return await axios.put(`${memberProfileApiUrl}`, memberProfile, config);
}

export async function addMemberProfile(newmemberProfile) {
  return await httpRequest(postMemberProfile.bind(this, newmemberProfile));
}

async function postMemberProfile(newmemberProfile) {
  let config = getHttpHeaders();
  return await axios.post(`${memberProfileApiUrl}`, newmemberProfile, config);
}

export async function deleteMemberProfile(id) {
  return await httpRequest(fetchDeleteMemberProfile.bind(this, id));
}

async function fetchDeleteMemberProfile(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${memberProfileApiUrl}/${id}`, config);
}
